import { useDashboardContext } from '../DashboardContext';

const DataLineGradientMask = () => {
    return (
        <linearGradient id="dataLineGradientMask" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%" stopColor="black" />
            <stop offset="5%" stopColor="white" />
            <stop offset="95%" stopColor="white" />
            <stop offset="100%" stopColor="black" />
        </linearGradient>
    );
};

export const DataLineSymbol = ({ name, deltaY, color }: { name: string; deltaY: number; color: string }) => {
    const { isDashboardAnimationsEnabled } = useDashboardContext();
    const dotsAmount = 9;
    const dots = new Array(dotsAmount).fill(null);
    const startY = deltaY < 0 ? Math.abs(deltaY) : 0;
    const endY = deltaY > 0 ? deltaY : 0;
    const height = 4 + Math.abs(deltaY);
    const path = [`M0,${2 + startY}`, `L220,${2 + endY}`];
    const duration = 18 * 1000;

    return (
        <symbol id={name} viewBox={`0 0 220 ${height}`}>
            <mask id={name + 'Mask'}>
                <rect width="220" height={height} fill="url(#dataLineGradientMask)"></rect>
            </mask>
            <g mask={'url(#' + name + 'Mask)'}>
                {dots.map((d, i) => {
                    if (isDashboardAnimationsEnabled) {
                        // Animated dots
                        return (
                            <circle r="1.5" fill={color} key={i}>
                                <animateMotion
                                    dur={duration + 'ms'}
                                    begin={Math.round((duration / dotsAmount) * i) + 'ms'}
                                    repeatCount="indefinite"
                                    path={path.join(' ')}
                                />
                            </circle>
                        );
                    } else {
                        // Static dots evenly distributed along the line
                        const x = (220 / (dotsAmount - 1)) * i;
                        const y = startY + (endY - startY) * (i / (dotsAmount - 1)) + 2;
                        return <circle r="1.5" fill={color} cx={x} cy={y} key={i} />;
                    }
                })}
            </g>
        </symbol>
    );
};

export const DataLineDefs = () => {
    return (
        <>
            <DataLineGradientMask />
            <DataLineSymbol name="dataLineTopLeft" deltaY={120} color={'white'} />
            <DataLineSymbol name="dataLineLeft" deltaY={0} color={'white'} />
            <DataLineSymbol name="dataLineBottomLeft" deltaY={-120} color={'white'} />
            <DataLineSymbol name="dataLineTopRight" deltaY={120} color={'#FF7F3E'} />
            <DataLineSymbol name="dataLineRight" deltaY={0} color={'#FF7F3E'} />
            <DataLineSymbol name="dataLineBottomRight" deltaY={-120} color={'#FF7F3E'} />
        </>
    );
};

export const DataLines = () => {
    return (
        <g>
            <g>
                <svg y="-15%" x="2%" width="25%">
                    <use href="#dataLineTopLeft"></use>
                </svg>
                <svg y="0%" x="2%" width="25%">
                    <use href="#dataLineLeft"></use>
                </svg>
                <svg y="15%" x="2%" width="25%">
                    <use href="#dataLineBottomLeft"></use>
                </svg>
            </g>
            <g>
                <svg y="15%" x="75%" width="25%">
                    <use href="#dataLineTopRight"></use>
                </svg>
                <svg y="0%" x="75%" width="25%">
                    <use href="#dataLineRight"></use>
                </svg>
                <svg y="-15%" x="75%" width="25%">
                    <use href="#dataLineBottomRight"></use>
                </svg>
            </g>
        </g>
    );
};
